<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks :quick_links="quick_links"></QuickSideLinks>
      <v-divider class="mt-4"></v-divider>
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>

    <CenterPageColumn :has_nav_bar="true">
      <CenterNavbar
        :crumps="[]"
        title="About Us"
        :width_class="page_info.center_width_class"
      ></CenterNavbar>

      <div
        class="d-flex justify-center pt-5 mb-0 componet-has-nav-bar white"
        id="about_top"
      >
        <v-img
          alt="Botswana Services Logo"
          class="shrink mr-1 mobile-app-bar-logo"
          contain
          src="https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1599568893/botswana%20services/website%20assets/logo_yyz06i.png"
          transition="scale-transition"
          width="350"
        />
      </div>
      <div class="d-flex justify-center pt-0 mb-0">
        <v-img
          alt="Woman on computer"
          class="shrink mr-0 mobile-app-bar-logo"
          contain
          src="https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601120472/botswana%20services/website%20assets/register_b_riojdv.png"
          transition="scale-transition"
        />
      </div>
      <CardedSectionHeader
        icon="mdi-form-select"
        label="What is Botswana Services ?"
        id="about_introduction"
      ></CardedSectionHeader>
      <CardedDisplay>
        <PlainDisplay :show_icon="false">
          <p class="font-weight-medium text--darken-1">
            <b>Botswana Services</b> is the IP of Solidcare Service PTY LTD,
            which is a business solution focused company. <br />
            <br />
            <b
              >Botswana Services is a locally developed online business
              directory</b
            >
            and represents a great marketing opportunity for various local
            companies and organizations. The Web Application captures and
            displays registered business information and with this information
            customer can search for business by location, category, services
            provided, viewing contact information, company description, opening
            and closing hours, giving customer’s readily accessible information
            from the comfort of their home using their mobile devices, laptops
            or personal computers. This greatly assists anyone looking for any
            particular business/service to find them easier and with that get a
            lot more options when looking for services in a particular industry.
            Our directory is search targeted, timely and very cost effective,
            displaying business categorically and listing them in an industry
            specific manner.
          </p>
        </PlainDisplay>
      </CardedDisplay>
      <v-divider></v-divider>
      <CardedSectionHeader
        icon="mdi-form-select"
        label="Our Objectives"
        id="about_objectives"
      ></CardedSectionHeader>
      <CardedDisplay>
        <PlainDisplay :show_icon="false">
          <p class="font-weight-medium text--darken-1">
            <b>1) </b> To provide consumer with reliable, up to date business
            detail and services on the directory. <br />
            <br />
            <b>2) </b> Provide customers with real time access to service
            providers through an easy to use and secure web application.
            <br />
            <br />
            <b>3) </b> Save time for consumers by enabling them to process these
            services quickly, efficiently, smoothly and safely 24/7.
          </p>
        </PlainDisplay>
      </CardedDisplay>
      <div class="d-flex justify-center pt-0 mb-0">
        <v-img
          alt="men at work"
          class="shrink mr-0 mobile-app-bar-logo"
          contain
          src="https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601122481/botswana%20services/website%20assets/bots_men_eercbe.png"
          transition="scale-transition"
        />
      </div>
      <v-divider></v-divider>
      <CardedSectionHeader
        icon="mdi-form-select"
        label="Potential Target Market"
        id="about_market"
      ></CardedSectionHeader>
      <CardedDisplay>
        <PlainDisplay :show_icon="false">
          <p class="font-weight-medium text--darken-1">
            <b>Botswana Service Web Application </b>is an existing application
            that has been in the development and testing phase, with the
            inputting of business information solely done by employees of
            Solidcare Services. This is no longer the issue since more
            functionality has been added to the application allowing for to
            enter and manger their own information without the intervention of
            the application administration. Our intended clients for the
            application are:
            <br />
            <b>• Large scale businesses </b><br />
            <b>•Small scale Business </b> <br />
            <b>•Individual (Users looking for services) </b> <br /><br />
            CORPORATE <br />
            <b>• Private companies </b> <br />
            <b>• Parastatal</b> <br />
            <b>• Government Offices</b> <br /><br /><br />
          </p>
        </PlainDisplay>
      </CardedDisplay>
      <v-divider></v-divider>
      <CardedSectionHeader
        icon="mdi-form-select"
        label="How the platform Works:"
        id="about_how"
      ></CardedSectionHeader>
      <CardedDisplay>
        <PlainDisplay :show_icon="false">
          <p class="font-weight-medium text--darken-1">
            <b>Sellers and the system</b> <br />
            <b>1.</b> The sellers has a dashboard which they use to access the
            system. <br />
            <b>2.</b> Attributes of the seller dashboard; <br />
            •Add product----> add tittle, description, product picture,
            category, shipping details E.g. weight, product identification
            number, price (normal and sale), upselling and cross selling options
            <br />
            •Bulk upload option for products over 100 using excel <br />
            •View report of most viewed product, sales and order summary <br />
            •Change store details and edit important information such as banking
            details and advertising content. <br />
          </p>
          <v-row>
            <v-col class="pa-4">
              <b>CONSUMERS AND THE SYSTEM</b><br />
              <div class="text-left pl-4">
                <b>•</b> The consumers should be able to register and login to
                the system <br />
                <b>•</b> They should be able to view all categories, featured
                products and product short descriptions without logging in<br />
                <b>•</b> Should be able to buy a product<br />
                <b>•</b> Should be able to review a seller<br />
                <b>•</b> Should be able to view contact details of the seller<br />
                <b>•</b> Should be able to chat with the seller<br />
                <b>•</b> Should be able to register their business contacts on
                the system<br />
              </div>
            </v-col>
            <v-col class="pa-4">
              <b>BUSINESS OWNER</b><br />
              <div class="text-left">
                <b>•</b> Create account<br />
                <b>•</b> Login<br />
                <b>•</b> Add business<br />
                <b>•</b> View their business<br />
                <b>•</b> Update their business information<br />
                <b>•</b> View their business ratings<br />
                <b>•</b> Receive messages and emails when registering<br />
                <b>•</b> Can select multiple business categories<br />
                <b>•</b> Can make sales online<br />
                <b>•</b> Advertise on the platform<br />
                <b>•</b> Can serve as a link to your online store<br />
              </div>
            </v-col>
          </v-row>
        </PlainDisplay>
      </CardedDisplay>
      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>

    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>


<script>
import Page from "./../../components/Page";

import SidePageColumn from "./../../components/SidePageColumn";
import QuickSideLinks from "./../../components/QuickSideLinks";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";

import CenterPageColumn from "./../../components/CenterPageColumn";
import CenterNavbar from "./../../components/CenterNavbar";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import CardedDisplay from "./../../components/CardedDisplay";
import PlainDisplay from "./../../components/PlainDisplay";
import Footer from "./../../components/CenterFooter";

import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";

import page_info from "./../../lib/page_info";
import ServerClient from "./../../lib/ServerClient";

export default {
  name: "Contact",
  components: {
    Page,
    SidePageColumn,
    QuickSideLinks,
    FeaturedSidePromotions,
    CenterPageColumn,
    CenterNavbar,
    CardedSectionHeader,
    CardedDisplay,
    PlainDisplay,
    Footer,
    SelfPromoAdd,
    HomeSideAdsContainer,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: "about",
    quick_links: [
      {
        text: "Introduction",
        href: "#about_introduction",
      },
      {
        text: "Our Objectives",
        href: "#about_objectives",
      },
      {
        text: "Potential Target Market",
        href: "#about_market",
      },
      {
        text: "How the platform Works:",
        href: "#about_how",
      },
    ],
    page_info: page_info,
    page_contacts: page_info.get_contacts_list(),
    page_social_contacts: page_info.get_social_media_links(),
    contact_form_errors: [],
    contact_us_success_message: "",
  }),
  mounted() {
    //https://stackoverflow.com/questions/54770883/how-to-navigate-to-different-section-in-the-same-page-using-vuetify
    var options = {
      offset: 102,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#about_top", options);
  },
};
</script>